import { useEffect, useState } from "react";
import { API_GATEWAY_ENDPOINT } from "../../../../constants/api";

const LAMBDA_URL = API_GATEWAY_ENDPOINT+"jumbo/get-horometro-maquina-rango-fechas";

export function useGetHorometroRangoFechas(idMaquina, fechaInicio, fechaFinal, refreshKey) {
  const [horometro, setHorometro] = useState([]);
  const [loadingHorometro, setLoadingHorometro] = useState(false);
  const [errorHorometro, setErrorHorometro] = useState(null);

  useEffect(() => {
    const getHorometro = async () => {
      setLoadingHorometro(true);
      setErrorHorometro(null);

      try {
        const response = await fetch(
          LAMBDA_URL,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Api-Key": `${process.env.REACT_APP_API_KEY}`
            },
            body: JSON.stringify({
              idMaquina: idMaquina,
              startDate: fechaInicio,
              endDate: fechaFinal
            })
          }
        );

        if (!response.ok) {
          setHorometro([]);
          setErrorHorometro("Hubo un error al intentar obtener los datos.");
          return;
        }

        const { data } = await response.json();

        if (data.length > 0) {
          setHorometro(data);
        } else {
          setHorometro([]);
          setErrorHorometro("No se encontraron datos para el rango de fechas.");
        }
      } catch (error) {
        setErrorHorometro("Hubo un error al intentar obtener los datos.");
      } finally {
        setLoadingHorometro(false);
      }
    };

    getHorometro();
  }, [idMaquina, fechaInicio, fechaFinal, refreshKey]);

  return {
    horometro,
    loadingHorometro,
    errorHorometro
  };
}
